<template>
  <div>
    <div class="page-back" v-if="!isExamMode">
      <i class="el-icon-arrow-left" @click="goBack()"
        ><span class="desc">{{ $t('mark_back') }}</span></i
      >
    </div>
    <Progress-simulation-high
      v-if="resourceList.length"
      :selectList="resourceList"
      @currentSelect="currentSelect($event)"
      @play="playAudio"
      @pause="pauseAudio"
      @stop="playStop"
      @submitAnswer="submitAnswer"
      @changeTime="changeTime"
      @changePartTime="changePartTime"
      @startExamAudio="startExamAudio"
      :title="filterPaperName(titleTrans)"
      ref="progress"
      :answerObject="answerObject"
      :answerNotesArray="answerNotesArray"
      :showButtonPlay="showButtonPlay"
      :showButtonPause="showButtonPause"
      :time="time"
      :partTime="partTime"
      :partCode="partCode"
      :isShowCountDown="isShowCountDown"
      :playVoiceTime="playVoiceTime"
      :isExamMode="isExamMode"
      :listenNumList="listenNumList"
      :partProgressList="partProgressList"
      :isMarked="isMarked"
      :markIdList="markIdList"
      :examinationId="examId"
      :isPlaying="isPlaying"
      :speakingTestAudio="speakingTestAudio"
      @progressStatus="changeProgressStatus($event)"
    >
      <div slot="content">
        <!-- 既兼容新资源格式还要兼容老资源格式 -->
        <component
          :is="currentHSKComponent"
          :currItem="currItem"
          :jsonData="currItem"
          :isExamMode="isExamMode"
          :isShowAnAnalysis="!isExamMode"
          :leftTime="time"
          @saveRes="saveRes($event)"
          @focusQuestion="focusQuestion"
          @handleRecordEnd="handleRecordEnd"
          @handleRecordTypeListenEnd="handleRecordTypeListenEnd"
          :writeIsBegin="writeIsBegin"
          ref="componentRef"
          :key="`${currItem.count}_${randomData}`"
          :ansProgressStatus="ansProgressStatus"
          :baseUrl="rootPath"
          :isMarked="isMarked"
          :autoHandleAudio="autoHandleAudio"
        >
        </component>
      </div>
    </Progress-simulation-high>
  </div>
</template>

<script>
import ProgressSimulationHigh from '@/components/hsk/progressSimulationHigh.vue'
import Judgment from '@/components/hsk/judgment'
import SelectPicByVoice from '@/components/hsk/selectPicByVoice'
import SelectTextByVoice from '@/components/hsk/selectTextByVoice'
import SetChoosePicByText from '@/components/hsk/setChoosePicByText'
import SetChoosePicByVoiceSimulation from '@/components/hsk/setChoosePicByVoiceSimulation'
import SetChooseTextByText from '@/components/hsk/setChooseTextByText'
import JoinSentence from '@/components/hsk/joinSentence'
import FillInBlank from '@/components/hsk/fillInBlank'
import ReadingOrder from '@/components/hsk/readingOrder'
import setChooseTextByVoiceSimulation from '@/components/hsk/setChooseTextByVoiceSimulation'
import SetReadChooseTextBySentence from '@/components/hsk/setReadChooseTextBySentence'
import SetReadChooseTextFillBlank from '@/components/hsk/setReadChooseTextFillBlank'
import SelectTextReadingComprehension from '@/components/hsk/selectTextReadingComprehension'
import abbreviationSimulation from '@/components/hsk/abbreviationSimulation'
import MakeSentence from '@/components/hsk/makeSentence'
import SetJudgmentByVoiceSimulation from '@/components/hsk/setJudgmentByVoiceSimulation'
import SetChooseOrInputByVoice from '@/components/hsk/setChooseOrInputByVoiceSimulation'
import SetReadSubjectiveAnswer from '@/components/hsk/setReadSubjectiveAnswer'
import CountDownMakeSentence from '@/components/hsk/countDownMakeSentence'
import RecordByVoice from '@/components/hsk/recordByVoice'
import { HSK_SIMULATION_COMPONENTS, MARK_RESULT_TYPE, VOICE_EXTEND_TIME } from '@/config'
import { backLayerHandler, getQueryString, changeURLArg } from '@/utils/utils'
import { getToken } from '@/utils/cache'
import ApiPath from '@/serves/path'
import analytics from '@/utils/AnalyticsCenter'
import { getSegmentDuration, getSegmentPartsDuration } from '@/utils/hskTool'
// import lifecycle from 'page-lifecycle'
export default {
  components: {
    ProgressSimulationHigh,
    Judgment,
    SelectPicByVoice,
    SelectTextByVoice,
    SetChoosePicByText,
    SetChoosePicByVoiceSimulation,
    SetChooseTextByText,
    JoinSentence,
    FillInBlank,
    ReadingOrder,
    setChooseTextByVoiceSimulation,
    SetReadChooseTextBySentence,
    SetReadChooseTextFillBlank,
    SelectTextReadingComprehension,
    MakeSentence,
    abbreviationSimulation,
    SetJudgmentByVoiceSimulation,
    SetChooseOrInputByVoice,
    SetReadSubjectiveAnswer,
    CountDownMakeSentence,
    RecordByVoice,
  },
  data() {
    return {
      // 组装后的整套试卷数据
      resourceList: [],
      // 当前选中题型的全部信息
      currItem: {},
      // 用户选择的答案数据
      answerObject: {},
      // dialogVisible: false,
      time: -1, // 倒计时时间
      partTime: -1, // 模块倒计时
      partCode: null,
      //是否显示播放按钮
      showButtonPlay: true,
      showButtonPause: false,
      // 是否第一个未作答的题
      isFirstQuestion: false,
      // 作答记录数组
      answerNotesArray: [],
      // 是否显示倒计时（答题模式听力环节和阅卷模式不显示）
      isShowCountDown: true,
      // 是否提交了答案
      isSubmitAnswer: false,
      // 试卷名称的多语言
      titleTrans: {},
      paperType: '', // 当前语言下的试卷名称
      // 音频总时长
      playVoiceTime: '',
      // 环节流程数组-主要用来获取倒计时时间
      partProgressList: [],
      // 听力回顾音频
      explainAudio: '',
      // 口语试音使用
      speakingTestAudio: '',
      // 记录听力音频那些播放过
      videoPlayList: [],
      // 听力每题音频携带音频音频数量数组
      listenNumList: [],
      // 书写题是否开始
      writeIsBegin: 0,
      // 当前环节所处的阶段 0 预览 1 作答 2 回顾
      ansProgressStatus: 0,
      randomData: '',
      examination_id: '',
      // 资源根路径
      rootPath: '',
      // 试卷是否下架
      paperOff: false,
      // 是否批改
      isMarked: 2, // 0 未批改 1批改中 2已批改
      markIdList: [], // 需要批改的题ID
      // 等级类型和名称 eg：hsk5
      examType: '',
      // 保存一下考试的 examination_id
      examId: '',
      // 音频控件是否暂停，用于耳机插拔场景
      playerPaused: false,
      // 点击了退出登录
      onClickLogout: false,
      // 考试里面所有的听力合集
      listenAllList: [],
      isPlaying: false,
      // 重置情况下，翻译||口语有答案，但在某个题干播放结束后，需要显示录音；
      autoHandleAudio: -1,
    }
  },
  computed: {
    //当前题型组件
    currentHSKComponent() {
      let component = HSK_SIMULATION_COMPONENTS[this.currItem.topic_type]
      console.log('component', component)
      console.log('this.currItem', this.currItem)
      return component
    },
    //是否是答题模式
    isExamMode() {
      return !(this.$route.query.paperStatus == 1)
    },
    isLogin() {
      return this.$store.state.user.login
    },
  },

  async mounted() {
    this.pageInitPlayerSetting()
    await this.getPaperDetails()
    await this.getQuesList()
    /**
     * 监听页面刷新或关闭事件
     */
    const that = this
    window.onbeforeunload = async () => {
      // 关闭浏览器保存答题结果
      // that.playStop();
      // 刷新或者离开埋点

      analytics.logEvent('hskweb_mockClick_beforeunload', {
        url: location.href,
      })
      sessionStorage.setItem('onbeforeunload', 'simulation')
      localStorage.removeItem('bigIndex')
      let status = that.$refs.progress.ansProgressStatus != 2
      // that.$refs.progress.$refs.countDown.pause();
      this.$store.dispatch('notifLogout', false)
      await that.$refs.progress.saveApiRequest('', status)
      return ''
    }
    // document.addEventListener('visibilitychange', () => {
    //   if (document.hidden) {
    //     // 页面切换到后台
    //     this.$player.pause()
    //     alert('页面切换到后台');
    //   } else {
    //     // 页面切换到前台
    //     let audioPath = this.rootPath + this.currItem.content;
    //     alert(audioPath)
    //     this.$player.play(audioPath, "", {});
    //     alert('页面切换到前台');
    //   }
    // });
    window.addEventListener('HSKVoice', () => {
      that.isExamMode && that.changeIndex()
    })
    /**
     * 监听音频设备的变化保证插拔耳机音频播放不影响
     */
    try {
      navigator.mediaDevices.ondevicechange = () => {
        try {
          navigator.mediaDevices.enumerateDevices().then((devices) => {
            // 非听力环节或者听力回顾环节不处理
            const ansProgressStatus = +this.$refs.progress.ansProgressStatus
            if (this.currItem.segment_code !== 'listen' || ansProgressStatus === 2) return
            // 检查是否有音频设备
            var hasAudioInput = devices.some((device) => {
              return device.kind === 'audioinput' && device.deviceId !== 'default'
            })
            // 暂停播放
            if (!hasAudioInput) {
              this.$player.pause()
              this.playerPaused = true
              this.$store.dispatch('setPartForAudio', {
                isPaused: this.playerPaused,
              })
              console.log('Audio output device disconnected. Audio paused.')
            } else {
              // 继续播放
              // 如果是听力预览环节并且是非暂停状态，则播放预览音频
              if (ansProgressStatus === 0) {
                // 如果是非暂停代表是首次进入页面连接音频设备无须处理
                if (!this.playerPaused) return
                this.$player.play(this.explainAudio)
              } else {
                // 听力正式环节播放当前音频
                const voiceIndex = this.$refs.progress && this.$refs.progress.currentVoiceIndex
                const voiceItem = this.listenAllList[voiceIndex - 1]
                let audioPath = this.rootPath + voiceItem.audio_url
                console.log('audioPath', audioPath)
                this.$player.play(audioPath)
              }
              this.playerPaused = false
              this.$store.dispatch('setPartForAudio', {
                isPaused: this.playerPaused,
              })
              console.log('Audio device connected. Audio play.')
            }
          })
        } catch (error) {
          console.error('Error in ondevicechange event:', error)
        }
      }
    } catch (error) {
      console.log('error in navigator.mediaDevices', error)
    }
  },
  watch: {
    // 监听当前题变了,播放状态按钮禁用,只有同一个题才播放状态(当前语音播放的题跟 答题卡上选中的题)
    currItem: {
      handler(newVal) {
        console.log('currItem------', newVal)
        let isListenGroup =
          newVal.topic_type == 'ea' &&
          newVal.questions.find((item) => item.listen && item.listen.audio_file)

        if (
          newVal.segment_code == 'listen' &&
          !this.ifsetListen(newVal.topic_type) &&
          !isListenGroup
        ) {
          if (
            this.$refs.progress.currentVoiceIndex == this.$refs.progress.currentQuesIndex &&
            this.$refs.progress.ansProgressStatus == 1
          ) {
            this.showButtonPlay = false
            this.showButtonPause = true
          } else {
            this.showButtonPlay = true
            this.showButtonPause = false
          }
        } else {
          // 听力套题的情况

          this.ansProgressStatus = this.$refs.progress.ansProgressStatus
          this.showButtonPlay = false
          this.showButtonPause = false
          console.log(this.showButtonPlay, ' this.showButtonPlay')
        }
      },
      deep: true,
    },
    // 当前题型组件
    currentHSKComponent(val, oldVal) {
      // 埋点-组件切换
      analytics.logEvent('hskweb_mockflow_part', {
        prevPart: oldVal || '',
        part: val,
      })
    },
    '$store.state.simulation.beforeLogout': function (val) {
      console.log('考试过程中点击退出登录')
      if (val) {
        this.$router.push('/')
        this.onClickLogout = true
      }
    },
  },
  methods: {
    ifsetListen(topic_type) {
      let listenSetArr = ['xt', 'lt', 'pr', 'lr', 'ts', 'kt']
      return listenSetArr.indexOf(topic_type) > -1 ? true : false
    },
    pageInitPlayerSetting() {
      try {
        this.$player.onloaderrored = () => {
          console.log('get loadError')
          const _this = this
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('hsk_audio_error'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              window.location.reload()
              layer.close(index)
            },
            btn2: (index) => {
              layer.close(index)
            },
          })
        }
        this.$player.onplayerrored = () => {
          console.log('get loadError')
          const _this = this
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('hsk_audio_error'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              window.location.reload()
              layer.close(index)
            },
            btn2: (index) => {
              layer.close(index)
            },
          })
        }
        this.watchMethods(this.$player, (m, v) => {
          if (m == 'setPlayClass') {
            if (v.length > 0 && v[0] == 'play') {
              this.isPlaying = true
            } else {
              this.isPlaying = false
            }
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    watchMethods(o, callback) {
      const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(o))
      methods.forEach((method) => {
        if (typeof o[method] === 'function' && method !== 'constructor') {
          const fn = o[method]
          o[method] = (...args) => {
            callback && callback(method, args)
            return fn.apply(o, args)
          }
        }
      })
    },
    // 获取试卷总时长等信息，组装数据
    getPaperDetails() {
      return new Promise((resolve) => {
        utilV2.postData(
          ApiPath.hsk_paper_repare,
          {
            paperId: this.$route.query.paperId,
            examinationType: this.$route.query.examinationType,
            examination_id: this.$route.query.examination_id,
          },
          (data) => {
            // 当前语言下的试卷名称
            this.paperType = this.filterPaperName(
              data.titleTrans ? JSON.parse(data.titleTrans) : ''
            )
            // 试卷名称多语言
            this.titleTrans = JSON.parse(data.titleTrans)
            this.examType = data.levelName
            let mixpanelParams = {
              paper_type: this.paperType,
              exam_type: this.examType,
            }
            analytics.logEvent('hskweb_mockexam_view', mixpanelParams)
            // 试卷引导音频
            this.explainAudio = data.explainAudio
            // 纯音乐，口语试音使用
            this.speakingTestAudio = data.levelExplainAudio
            // 获取资源index.json文件
            this.rootPath = data.resource_url.slice(0, -4) + '/'
            // 拼装环节数组(除听力外预览跟回顾时间都为0)
            let prevCount = 0 //
            this.partProgressList = data.segments.map((item) => {
              let obj = {
                segmentCode: item.segmentCode,
                duration: getSegmentDuration(item, data.levelId),
                previewTime: item.segmentCode == 'listen' ? -1 : 0,
                reviewTime:
                  item.segmentCode == 'listen' ? data.listenReviewDuration * 60 * 1000 : 0,
                questionCount: item.questionCount,
                parts: getSegmentPartsDuration(item, prevCount),
              }
              prevCount += item.questionCount
              return obj
            })
            console.log(this.partProgressList, 'this.partProgressList')
            resolve()
          }
        )
      })
    },
    // 获取索引页数据
    getQuesList() {
      window.utilV2.getJSON(`${this.rootPath}index.json`, (data) => {
        this.resourceList = []
        // 重新组装索引页数据（整套试卷的数据）
        let tempArr = []
        // 试卷数据
        let Data = []
        // 重组数据结构，把index.json中返回的平面类型数据结构转化成大题嵌小题类型层级结构
        for (let i = 0; i < data.items.length; i++) {
          if (tempArr.indexOf(data.items[i].segment_code) === -1) {
            Data.push({
              name: data.items[i].segment_code,
              nameStr: this.findSegmentCodeStr(data.items[i].segment_code),
              dataInfo: [data.items[i]],
            })
            tempArr.push(data.items[i].segment_code)
          } else {
            for (let j = 0; j < Data.length; j++) {
              if (Data[j].name == data.items[i].segment_code) {
                Data[j].dataInfo.push(data.items[i])
                break
              }
            }
          }
        }
        console.log('Data', Data)
        // 取出所有题型的题目 再次重新拼凑
        let quesList = []
        // 记录大题序号
        let bigIndex = 0
        // 获取各个题型的资源
        Data.forEach((itemData) => {
          itemData.dataInfo.forEach((data) => {
            quesList.push(this.apiRequest(data.topic_items))
          })
        })
        // 对每个题目进行详细处理，生成最终的题目结构，存储在 fnlData 中，并赋值给对应的 data.questionList
        Promise.all(quesList).then((res) => {
          console.log('res', res)
          let i = 0
          Data.forEach((text) => {
            text.dataInfo.forEach((data) => {
              let fnlData = []
              const { topic_type, part_code, segment_code } = data
              for (let j = 0; j < res[i].length; j++) {
                bigIndex++
                // 套题会有questions的key值，将questions里的小题平铺
                if (res[i][j].questions) {
                  for (let k = 0; k < res[i][j].questions.length; k++) {
                    const { questions, listen, screen_text, config } = res[i][j]
                    let deepQuestion = JSON.parse(JSON.stringify(questions))
                    Object.assign(res[i][j].questions[k], {
                      topic_type,
                      questions: deepQuestion,
                      part_code,
                      segment_code,
                      ifGroup: true, // 套题
                      num: questions.length - k, // 套题下的倒数第几题
                      nnum: k + 1, // 套题下的第几题
                      bigIndex,
                      top_listen: listen, // 套题的题干
                      top_screen_text: screen_text,
                      config,
                    })
                    fnlData.push(res[i][j].questions[k])
                  }
                  bigIndex += res[i][j].questions.length - 1
                }
                // 非套题
                else {
                  Object.assign(res[i][j], {
                    topic_type,
                    part_code,
                    segment_code,
                    ifGroup: false,
                    num: 1,
                    nnum: 1,
                    bigIndex,
                  })
                  fnlData.push(res[i][j])
                }
              }
              i++
              data.questionList = fnlData
              // 过滤需要批改的作业
              if (Object.values(MARK_RESULT_TYPE).includes(topic_type)) {
                if (topic_type == 'lr') {
                  this.markIdList.push(
                    ...fnlData
                      .filter((e) => {
                        return !e.is_example && e.content_tk
                      })
                      .map((qItem) => qItem.index)
                  )
                } else {
                  this.markIdList.push(
                    ...fnlData.filter((e) => !e.is_example).map((qItem) => qItem.index)
                  )
                }
              }
              console.log(this.markIdList, 'this.markIdList')
            })
          })
          console.log('组装完的数据', Data)
          this.resourceList = Data

          // 获取每个题型有几个音频（如果题干有音频则加到这组题中第一个）
          this.resourceList.forEach((item) => {
            for (let i = 0; i < item.dataInfo.length; i++) {
              if (
                item.name == 'listen' ||
                item.name == 'speaking' ||
                (item.name == 'translation' && item.dataInfo[i].topic_type == 'ts')
              ) {
                // 有听力
                item.dataInfo[i].questionList.forEach((qus) => {
                  let i = 0
                  let obj = {
                    audio_text: '',
                    audio_url: '',
                    index: qus.index || '',
                    is_stem: false, // 题干
                    is_example: qus.is_example || false,
                    segmentCode: item.name,
                  }
                  let objs = []
                  // 套题的第一个，将题干音也存为一条播放对象
                  if (qus.top_listen && qus.nnum == 1) {
                    i++
                    obj.audio_text = qus.top_listen.audio_text
                    obj.audio_url = qus.top_listen.audio_file
                    obj.is_stem = true
                    objs.push({ ...obj })
                  }
                  // 目前看listen与content是两种资源结构
                  if (qus.listen) {
                    i++
                    obj.audio_text = qus.listen.audio_text
                    obj.audio_url = qus.listen.audio_file
                    obj.is_stem = false
                    objs.push({ ...obj })
                  }
                  if (qus.content) {
                    i++
                    obj.audio_text = qus.content_sentence
                    obj.audio_url = qus.content
                    obj.is_stem = false
                    objs.push({ ...obj })
                  }
                  this.listenNumList.push(i)

                  this.listenAllList = [...this.listenAllList, ...objs]
                })
              } else {
                // 无听力
                item.dataInfo[i].questionList.forEach((ques) => {
                  this.listenNumList.push(0)
                })
              }
            }
            this.listenAllList = this.listenAllList.map((item, index) => ({
              ...item,
              count: index,
            }))
            console.log(this.listenAllList, 'listenAllList')
            // }
          })
          console.log('listenNumList', this.listenNumList)
          console.log(this.listenAllList, 'this.listenAllList')
          console.log(this.resourceList, 'this.resourceListresourceListresourceListresourceList')
          // 不是答题模式时
          if (this.$route.query.paperStatus == 1) {
            this.isShowCountDown = false
            this.getFinishedRes()
          } else {
            // 答题模式-过程中刷新页面或者继续作答入口进入的，examination_id参数对于新作答的页面url中是没有的
            // 继续考试
            if (Number(this.$route.query.ansStatus) || this.$route.query.examination_id) {
              if (sessionStorage.onbeforeunload === 'simulation') {
                sessionStorage.removeItem('onbeforeunload')
                window.layer.open({
                  title: '',
                  closeBtn: 0,
                  content: this.$t('hsk_if_test'),
                  yes: (index) => {
                    // 点击继续考试
                    analytics.logEvent('hskweb_mockClick_continueExamBtn', {})
                    this.continueTest() // 继续考试
                    window.layer.close(index)
                  },
                })
              } else {
                this.continueTest() // 继续考试
              }
              // 重新作答或者开始作答的
            } else {
              this.initExaminationPaper()
            }
          }
        })
      })
    },
    // 初始化试卷状态
    initExaminationPaper() {
      const { query } = this.$route
      // 作业为4 试卷为2
      utilV2.postData(
        +query.examinationType === 4
          ? ApiPath.home_work_init_paper
          : ApiPath.hsk_init_emulation_paper,
        +query.examinationType === 4
          ? { assignment_id: query.assignment_id }
          : {
              paperId: query.paperId,
              examinationType: +query.examinationType,
              mock_type: query.mock_type,
            },
        (data) => {
          // console.log('初始化试卷状态', data)
          // 获取试卷id-赋值路由examination_id
          this.examId = data.examination_id || data
          if (window.location.href.indexOf('examination_id') == -1) {
            window.history.replaceState(
              {},
              '',
              window.location.href + `&examination_id=${data.examination_id || data}`
            )
          } else if (!getQueryString('examination_id')) {
            window.history.replaceState(
              {},
              '',
              changeURLArg('examination_id', data.examination_id || data)
            )
          }
          // 开始播放音频\取第一个题目
          console.log('this.resourceList', this.resourceList)
          console.log('this.partProgressList', this.partProgressList)
          this.time = this.partProgressList[0].previewTime
          // this.$refs.progress.previewVisible = true
          this.$player.play(this.explainAudio)
          this.$player.onended = () => {
            // 预览音频结束后初始化题目index
            this.$refs.progress.currentQuesIndex = 1
            this.$refs.progress.previewVisible = false
            this.$refs.progress.finish('init')
          }
          this.$refs.progress.selectQues()
          // 初始化完成进入
        },
        (data) => {
          if (data.errcode == 3004) {
            this.paperOff = true
            this.$message.warning(this.$t('test_paper_office'))
            this.$router.back(-1)
          } else if (data.errcode == 3001) {
            this.paperOff = true
            this.$message.warning(this.$t(data.errmsg))
            this.$router.back(-1)
          } else {
            this.paperOff = true
            this.$message.warning(data?.message)
            this.$router.back(-1)
          }
        }
      )
    },
    // 继续考试
    continueTest() {
      const { query } = this.$route
      utilV2.postData(ApiPath.hsk_get_list_answer, { ...query }, (data) => {
        console.log('data', data)
        // 考试的位置
        let continueCode = data.segmentCode
        // 试卷的作答记录
        this.answerNotesArray = data.questionAnswers
        // ？写作是否开始的状态
        this.writeIsBegin = data.abbreviationState
        // 设置为作答阶段
        if (this.$refs.progress) {
          this.$refs.progress.ansProgressStatus = 1
        }

        // 是否通过音频获取题号
        let ifQuestionIndexByVoice =
          continueCode == 'listen' || continueCode == 'speaking' ? true : false

        // 接口返回了segment,需要自己定位part位置
        let segmentObj = this.partProgressList.find((item) => {
          return item.segmentCode == continueCode
        })
        console.log(segmentObj, 'segmentObjsegmentObjsegmentObjsegmentObjsegmentObj')
        let ifHavepartCountDown = segmentObj.parts.some((part) => part.part_answer_time > -1)
        //需要定位part的情况是没有segment倒计时&&有part倒计时 (题型:7-9写作;7-9翻译第一部分)
        let partCode = null // partCode存在,说明当前正在使用part倒计时
        let lastPartCountDown = data.countDown
        console.log(lastPartCountDown)
        if (segmentObj.duration == -1 && ifHavepartCountDown) {
          if (data.countDown == -1) {
            // 重置模块，当前模块的countDown为最大值

            lastPartCountDown = segmentObj.parts[0].part_answer_time
            partCode = 1
          } else {
            // 普通的重新进入
            if (continueCode == 'translation' && data.countDown == -2) {
              // 进入翻译第二模块;
              ifQuestionIndexByVoice = true
            } else {
              //其他情况
              let len = segmentObj.parts.length
              for (let i = len - 1; i > -1; i--) {
                console.log('for循环开始', lastPartCountDown)
                if (segmentObj.parts[i].part_answer_time > -1) {
                  if (lastPartCountDown - segmentObj.parts[i].part_answer_time <= 0) {
                    console.log(lastPartCountDown, '减去当前模块是负数了')
                    partCode = segmentObj.parts[i].partCode
                    break
                  } else {
                    lastPartCountDown = lastPartCountDown - segmentObj.parts[i].part_answer_time
                  }
                }
              }
            }
          }
        }
        console.log(partCode, 'partCode')
        console.log(lastPartCountDown, 'lastPartCountDown')
        console.log(ifQuestionIndexByVoice, 'ifQuestionIndexByVoice')
        // 1. 通过音频播放的情况定位题号
        // todo 翻译第二环节定位||口语的定位;
        if (ifQuestionIndexByVoice) {
          // if (continueCode == 'speaking') {
          //   // 弹窗，弹窗以后调用方法；
          // } else {
          this.$refs.progress.currentVoiceIndex = data.audioIndex
          this.$refs.progress.currentQuesIndex = this.getQuesListIndexForVoice(
            this.$refs.progress.currentVoiceIndex
          )
          // if (continueCode == 'speaking') {
          //   this.$refs.progress.testRadioDialogShow = true
          // }
          // }
        }

        // 得到记录合并对象
        let j = 0
        // console.log(this.answerNotesArray)
        this.answerNotesArray.length &&
          this.resourceList.forEach((item) => {
            item.dataInfo.forEach((type) => {
              for (let i = 0; i < type.questionList.length; i++) {
                if (type.questionList[i].is_example) continue
                Object.assign(type.questionList[i], this.answerNotesArray[j])
                // 需要些额外的信息，后端没存进去在这里合并
                Object.assign(this.answerNotesArray[j], {
                  ifGroup: type.questionList[i].ifGroup,
                  num: type.questionList[i].num,
                  nnum: type.questionList[i].nnum,
                  count: type.questionList[i].count,
                })
                console.log(type, type.questionList[i], 'type.questionList[i]')
                if (
                  !this.isFirstQuestion &&
                  this.answerNotesArray &&
                  !this.answerNotesArray[j].answer &&
                  !ifQuestionIndexByVoice &&
                  type.questionList[i].segment_code == continueCode &&
                  partCode == type.part_code
                ) {
                  // 从part下找未作答题目
                  this.$refs.progress.currentVoiceIndex = this.$refs.progress.currentQuesIndex =
                    this.answerNotesArray[j].count + 1
                  this.isFirstQuestion = true
                } else if (
                  !this.isFirstQuestion &&
                  this.answerNotesArray &&
                  !this.answerNotesArray[j].answer &&
                  !ifQuestionIndexByVoice &&
                  type.questionList[i].segment_code == continueCode &&
                  !partCode
                ) {
                  // 非听力找出第一个未作答的题
                  this.$refs.progress.currentVoiceIndex = this.$refs.progress.currentQuesIndex =
                    this.answerNotesArray[j].count + 1
                  this.isFirstQuestion = true
                }
                j++
              }
            })
          })

        //  如果没有找到当前环节第一个未作答的题,则定位到当前环节最后一个题
        if (!this.isFirstQuestion && !ifQuestionIndexByVoice) {
          let continueCodeArr = []
          // 从part倒计时,限定查找数组在此part内
          if (partCode) {
            continueCodeArr = this.answerNotesArray.filter(
              (fil) => fil.segmentCode === continueCode && fil.partCode === partCode
            )
            // 从segment倒计时,限定查找数组在此segment内
          } else {
            continueCodeArr = this.answerNotesArray.filter(
              (fil) => fil.segmentCode === continueCode
            )
          }

          const continueCodeLast = continueCodeArr[continueCodeArr.length - 1]
          console.log('continueCodeLast: ', continueCodeLast)

          this.$refs.progress.currentVoiceIndex = this.$refs.progress.currentQuesIndex =
            continueCodeLast.count + 1
        }

        /**
         * 非听力部分重新赋值accumulationNum属性给子组件
         * getNumsBeforeCurrentSegmentCode为子组件中的方法，此方法对data.questionAnswers中的数据进行了扁平化处理，如果听力题中存在套题直接操作data.questionAnswers计数有误
         */
        if (continueCode !== 'listen') {
          this.$refs.progress.accumulationNum =
            this.$refs.progress.getNumsBeforeCurrentSegmentCode(continueCode) ||
            data.questionAnswers.find((item) => item.segmentCode === continueCode).count + 1
        }
        this.$nextTick(() => {
          this.$refs.progress.selectQues()
          let partProgress = this.partProgressList.find((item) => {
            return item.segmentCode == this.currItem.segment_code
          })
          this.partTime = partCode ? lastPartCountDown : -1
          this.partCode = partCode
          this.time =
            ifQuestionIndexByVoice || partCode
              ? -1
              : data.countDown == -1
              ? partProgress.duration // 如果是-1，则初始化了模块
              : data.countDown // 继续上次作答时间
          console.log(this.continuePartTime, ' this.continuePartTime')
          console.log(this.time, 'this.time')
          setTimeout(() => {
            if (!ifQuestionIndexByVoice && !partCode) {
              // 非音频控制 && 非part控制
              this.$refs.progress.$refs.countDown.start()
            } else if (!ifQuestionIndexByVoice && partCode) {
              // 非音频控制 && 是part控制
              this.$refs.progress.$refs.partCountDown.start()
            }
          })
        })
        console.log(this.resourceList, 'continue resourceListresourceListresourceListresourceList')
        console.log(
          this.answerNotesArray,
          'continue answerNotesArrayanswerNotesArrayanswerNotesArray'
        )
      })
    },
    // 请求每个题的json数据
    apiRequest(name) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let result
        await utilV2.getJSON(`${this.rootPath + name}`, (data) => {
          result = data.items
        })
        resolve(result)
      })
    },
    //根据segment_code返回多语言
    findSegmentCodeStr(code) {
      let codeStr = ''
      switch (code) {
        case 'listen':
          codeStr = this.$t('hsk_listen_name')
          break
        case 'read':
          codeStr = this.$t('hsk_read_name')
          break
        case 'write':
          codeStr = this.$t('hsk_write_name')
          break
        case 'translation':
          codeStr = this.$t('Traduction')
          break
        case 'speaking':
          codeStr = this.$t('speaking')
          break
        default:
          break
      }
      return codeStr
    },
    filterPaperName(nameTrans) {
      let language = localStorage.getItem('language')
      if (language === 'zh') {
        language = 'cn'
      }

      return nameTrans[language]
    },
    changeProgressStatus(val) {
      this.ansProgressStatus = val
    },

    /**
     * 提供给子组件改变时间用
     *
     * @param {number} val - ansProgressStatus  0 预览 1 作答 2 回顾
     */
    changeTime(val) {
      console.log()
      let partProgress = this.partProgressList.find((item) => {
        return item.segmentCode == this.currItem.segment_code
      })
      // console.log('val', val)
      // console.log('partProgress', partProgress)
      // this.time = val == 1 ? 10000 : 10000
      this.time = val == 1 ? partProgress.duration : partProgress.reviewTime
      // 当前环节是回顾环节
      if (this.$refs.progress.ansProgressStatus == 2) {
        this.showButtonPlay = true
        this.showButtonPause = false
      }
      if (this.time > 0) {
        this.$nextTick(() => {
          this.$refs.progress.$refs.countDown.reset()
          this.$refs.progress.$refs.countDown.start()
        })
      } else {
        this.$refs.progress.selectQues()
      }
    },
    changePartTime({ time, partCode }) {
      this.partTime = time
      this.partCode = partCode
      this.$nextTick(() => {
        if (time > -1) {
          this.$refs.progress.$refs.partCountDown.reset()
          this.$refs.progress.$refs.partCountDown.start()
        }
      })
    },
    // 根据题号获取待播放的音频;
    startExamAudio(nextListenPart) {
      console.log('调用了startExamAudio', 'nextListenPart:', nextListenPart)
      let nextIndex = nextListenPart.startQuestion
      let netxtListenItem = this.listenAllList.find((listenItem) => {
        return listenItem.index == nextIndex
      })
      console.log(netxtListenItem, 'netxtListenItem')
      if (netxtListenItem) {
        this.$refs.progress.currentVoiceIndex = netxtListenItem?.count + 1
        console.log(netxtListenItem?.count, 'netxtListenItem?.count')
        this.$refs.progress.currentQuesIndex = nextIndex
        console.log(this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex))
        this.$refs.progress.selectQues('', '', true)
      }
    },
    // 1选择答题卡后执行的 2 首次进入也会执行 3 继续考试也会走
    // 自动播放听力音频的播放方法
    currentSelect(obj) {
      // 翻译|口语切换题号的
      // console.log('this.currItem',this.currItem)
      // let segMentCode =
      // if (this.currItem.) {
      //   // 利用当前的voiceIndex 获取 题号；如果音频与题号相同，并且音频未播放过，播放；
      // }

      // 以下为对听力部分的处理
      console.log('选择答题卡 currentSelect ', obj)
      this.$store.dispatch('setPartForAudio', { part: obj.segment_code })
      // 既兼容老资源格式也兼容新的
      this.currItem = obj.listen ? { ...obj, content: obj.listen.audio_file } : { ...obj }
      // 兼容新资源格式
      let isListenGroup =
        obj.topic_type == 'ea' &&
        obj.questions.find((item) => item.listen && item.listen.audio_file)
      if (obj.topic_type == 'ts' || obj.segment_code == 'speaking') {
        // 是口译或者口语

        if (
          this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex) ==
            this.$refs.progress.currentQuesIndex &&
          this.$refs.progress.ansProgressStatus == 1 &&
          !this.videoPlayList[this.$refs.progress.currentVoiceIndex]
        ) {
          if (obj.topic_type == 'ts' || obj.topic_type == 'kt') {
            // 套题
            if (
              // 题干音频
              this.listenNumList[this.$refs.progress.currentQuesIndex - 1] > 1 &&
              this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex) !==
                this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex - 1)
            ) {
              // this.$refs.progress.currentQuesIndex = null
              let audioPath =
                this.rootPath +
                this.listenAllList[this.$refs.progress.currentVoiceIndex - 1].audio_url
              console.log(this.$refs.progress.currentVoiceIndex)
              console.log(
                this.listenAllList[this.$refs.progress.currentVoiceIndex],
                'this.listenAllList[this.$refs.progress.currentVoiceIndex]'
              )
              this.playAudio(false, audioPath)
            } else {
              // 小题音频
              this.playAudio()
            }
          } else {
            // 非套题
            this.playAudio()
          }
          this.videoPlayList[this.$refs.progress.currentVoiceIndex] = true
        }
      }

      // 非听力套题
      if (obj.segment_code == 'listen' && !this.ifsetListen(obj.topic_type) && !isListenGroup) {
        if (this.$route.query.paperStatus != 1) {
          setTimeout(() => {
            // 初始化成第一题
            // this.currentQuesIndex = this.currentVoiceIndex
            // 如果选择答题卡切换题目时,不自动播放切换题的音频
            if (
              this.$refs.progress.currentVoiceIndex == this.$refs.progress.currentQuesIndex &&
              this.$refs.progress.ansProgressStatus == 1 &&
              !this.videoPlayList[this.$refs.progress.currentQuesIndex]
            ) {
              console.log('是这里吗？？？？？')
              this.playAudio()
              this.videoPlayList[this.$refs.progress.currentQuesIndex] = true
            }
          }, 400)
        }
      } else if (
        // 听力套题
        (this.ifsetListen(obj.topic_type) || isListenGroup) &&
        this.$route.query.paperStatus != 1
      ) {
        this.showButtonPlay = false
        this.showButtonPause = false
        this.$nextTick(() => {
          if (
            this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex) ==
              this.$refs.progress.currentQuesIndex &&
            this.$refs.progress.ansProgressStatus == 1 &&
            !this.videoPlayList[this.$refs.progress.currentVoiceIndex]
          ) {
            // 满足此条件说需要播放听力的题干
            console.log('播放听力的index', this.$refs.progress.currentVoiceIndex)
            console.log(
              this.listenNumList[this.$refs.progress.currentQuesIndex - 1],
              'this.listenNumList[this.$refs.progress.currentQuesIndex - 1]'
            )
            console.log(
              this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex),
              this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex - 1)
            )
            if (
              this.listenNumList[this.$refs.progress.currentQuesIndex - 1] > 1 &&
              this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex) !==
                this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex - 1)
            ) {
              // this.$refs.progress.currentQuesIndex = null
              this.$refs.componentRef.autoPlay(obj, true)
            } else {
              this.$refs.componentRef.autoPlay(obj, false)
            }
            this.videoPlayList[this.$refs.progress.currentVoiceIndex] = true
          }
        })
      } else {
        this.showButtonPlay = false
        this.showButtonPause = false
      }
    },

    //点击播放音频与自动播放音频
    playAudio(isTryAgain, speakingStemUrl) {
      console.log('playAudio')
      // console.log('bo放音频:  ', isTryAgain)
      this.showButtonPlay = false
      this.showButtonPause = true
      const _this = this
      let audioPath = this.rootPath + this.currItem.content
      if (speakingStemUrl) {
        audioPath = speakingStemUrl
      }
      this.$player.play(audioPath, '', {}, isTryAgain)
      this.$player.onended = (e) => {
        // console.log('bo放音频:  onended')
        if (_this.isExamMode) {
          if (e == 'failed') {
            _this.playVoiceTime = 0
            layer.open({
              title: '',
              closeBtn: 0,
              content: _this.$t('common_video_failed'),
              btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
              yes: (index) => {
                _this.randomData = new Date().getTime()
                _this.playAudio(true)
                layer.close(index)
              },
              btn2: (index) => {
                _this.changeIndex()
                layer.close(index)
              },
            })
            _this.showButtonPlay = true
            _this.showButtonPause = false
          } else {
            // 听力结束继续播放下一题
            if (this.currItem.segment_code === 'listen') {
              setTimeout(() => {
                if (this.currItem.segment_code === 'listen' && !this.playerPaused) {
                  _this.playVoiceTime = 0
                  _this.showButtonPlay = true
                  _this.showButtonPause = false
                  _this.changeIndex()
                }
              }, VOICE_EXTEND_TIME * 1000)
            } else if (
              this.currItem.segment_code == 'translation' ||
              this.currItem.segment_code == 'speaking'
            ) {
              this.handleRecordTypeListenEnd()
            }

            // 翻译|口语引导音频结束,判断下一个音频是否还是
          }
        } else {
          _this.showButtonPlay = true
          _this.showButtonPause = false
        }
      }
      this.$player.onloaded = (e) => {
        // console.log('bo放音频:  onloaded', e)
        if (!e) return
        this.playVoiceTime = e + VOICE_EXTEND_TIME
        // console.log('playVoiceTime', this.playVoiceTime)
      }
    },
    // 开启 翻译| 口语的录音
    handleRecordTypeListenEnd() {
      console.log('触发父组件录音倒计时hanleRecordTypeListenEnd')
      const voiceIndex = this.$refs.progress && this.$refs.progress.currentVoiceIndex
      console.log(this.$refs.progress.currentVoiceIndex, 'this.$refs.progress.currentVoiceIndex')
      // 切换到当前题号
      this.$refs.progress.currentQuesIndex = this.getQuesListIndexForVoice(
        this.$refs.progress.currentVoiceIndex
      )
      console.log(this.$refs.progress.currentQuesIndex, 'this.$refs.progress.currentQuesIndex')
      console.log(
        this.answerNotesArray[this.$refs.progress.currentQuesIndex - 1],
        'this.answerNotesArray[this.$refs.progress.currentQuesIndex]'
      )
      if (
        this.listenAllList[voiceIndex] &&
        this.listenAllList[voiceIndex].index == this.listenAllList[voiceIndex - 1].index
      ) {
        //当前音频与下一个音频index相同,继续播放音频
        this.$refs.progress.currentVoiceIndex++
        this.$refs.progress.currentQuesIndex = this.getQuesListIndexForVoice(
          this.$refs.progress.currentVoiceIndex
        )
        this.$refs.progress.selectQues('', '', true)
        console.log('继续播放音频，', this.$refs.progress.currentQuesIndex)
      } else {
        // 某个题号要显示
        this.autoHandleAudio = this.$refs.progress.currentQuesIndex
        // index不同,进入录音环节
        // this.$refs.componentRef.recordDuration = this.currItem.seconds_limt
        this.$nextTick(() => {
          this.$refs.componentRef.handleStartRecord()
          //  this.$refs.progress.$refs.partCountDown.start()
        })
      }
    },
    // 结束 翻译|口语的录音(基本等同于听力的changeIndex事件)
    handleRecordEnd() {
      console.log('录音结束-父组件结束')
      const voiceIndex = this.$refs.progress && this.$refs.progress.currentVoiceIndex
      console.log('this.listenAllList:', this.listenAllList, 'voiceIndex:', voiceIndex)
      this.autoHandleAudio = -1
      if (this.findLastSegmentAudio('translation')) {
        //翻译模块的最后一题(currentVoiceIndex是翻译最后一个音频)
        console.log('finish translation')
        this.$refs.progress.finish('translation')
        return
      } else if (this.findLastSegmentAudio('speaking')) {
        console.log('finish speaking')
        // 口语模块的最后一题（currentVoiceIndex是口语最后一个音频）
        this.$refs.progress.finish('speaking')
        return
      }
      // 有下一个音频播放下一个音频

      if (this.listenAllList[voiceIndex]) {
        this.$refs.progress.currentVoiceIndex = voiceIndex + 1
        this.$refs.progress.currentQuesIndex = this.getQuesListIndexForVoice(
          this.$refs.progress.currentVoiceIndex
        )
        this.$refs.progress.selectQues('', '', true)
      }
      console.log(this.searchAnsNumber('speaking'), 'his.searchAnsNumber(speaking')
      console.log(
        this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex),
        'this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex)'
      )
      console.log(
        // this.resourceList[],
        'this.resourceListthis.resourceListthis.resourceListthis.resourceListthis.resourceList'
      )
    },
    findLastSegmentAudio(segmentName) {
      const voiceIndex = this.$refs.progress && this.$refs.progress.currentVoiceIndex
      let segmentListenList = []
      segmentListenList = this.listenAllList.filter((item) => {
        return item.segmentCode == segmentName
      })
      let lastOne = segmentListenList[segmentListenList.length - 1]
      console.log(lastOne, lastOne.count, 'lastOne')
      console.log(voiceIndex, 'voiceIndex')
      if (lastOne.count == voiceIndex - 1) {
        return true
      }
      return false
    },
    //点击暂停音频
    pauseAudio() {
      console.log('pauseAudio')
      this.$player.pause()
      this.showButtonPlay = true
      this.showButtonPause = false
    },
    //停止播放音频
    playStop() {
      console.log('playStop')
      if (
        ['listen', 'translation', 'speaking'].includes(this.currItem.segment_code) &&
        !this.ifsetListen(this.currItem.topic_type)
      ) {
        this.$player.stop()
        this.showButtonPlay = true
        this.showButtonPause = false
      } else if (this.ifsetListen(this.currItem.topic_type)) {
        this.$player.stop()
        this.showButtonPlay = false
        this.showButtonPause = false
      }
    },
    // 保存做完的题目
    saveRes(obj) {
      this.answerObject = obj
    },
    // 题目组件传出事件，焦点集中在某个套题的小题目上
    // (目前仅用于套题的主观题上，
    //  1）客观题聚焦题目==选择答案，保存答案具有题号切换的能力；
    //  2）主观题聚焦与输入答案是不同的事件，需要聚焦时切换题目)
    focusQuestion(questionIndex) {
      // 入参是点击的某个input框的题目index
      if (questionIndex) {
        this.$refs.progress.currentQuesIndex = questionIndex
      }
    },
    // 改变音频index以及题目index(只有听力才走此方法)
    changeIndex() {
      console.log('this.$refs.progress.currentVoiceIndex: ', this.$refs.progress?.currentVoiceIndex)
      analytics.logEvent('hskweb_mockflow_VoiceIndex', {
        index: this.$refs.progress?.currentVoiceIndex || 0,
      })
      if (
        this.$refs.progress &&
        this.searchAnsNumber('listen') ==
          this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex)
      ) {
        this.$refs.progress.ansProgressStatus == 2
        this.$refs.progress.finish('listen')
      } else {
        // this.isExamMode && this.changeIndex()
        // 获取听力一个多少个题（题干带音频算一个）
        let listenLength = 0
        this.listenNumList.forEach((item) => {
          listenLength += item
        })
        // 查询每个题型的数量
        if (this.$refs.progress && this.$refs.progress.currentVoiceIndex < listenLength) {
          this.$refs.progress.currentVoiceIndex++
          // 为了防止播放下一题听力index 对应的 quesindex 与提前点击下一题quesindex 相同导致quesindex watch不到，手动执行下一题
          if (
            this.$refs.progress.currentQuesIndex ==
            this.getQuesListIndexForVoice(this.$refs.progress.currentVoiceIndex)
          ) {
            this.$refs.progress.selectQues('', '', true)
          } else {
            this.$refs.progress.currentQuesIndex = this.getQuesListIndexForVoice(
              this.$refs.progress.currentVoiceIndex
            )
          }
          console.log(this.$refs.progress.currentQuesIndex, this.$refs.progress.currentVoiceIndex)
        }
      }
    },
    // 根据currentVoiceIndex获取当前处于哪个听力题（因有的听力题干包含听力）
    getQuesListIndexForVoice(val) {
      // listen--累加数目即可;
      let i = 0
      let sum = 0
      for (let j = 0; j < this.listenNumList.length; j++) {
        i += this.listenNumList[j]
        if (i >= val) {
          sum = j + 1
          break
        }
      }
      return sum
    },
    // 完成后查看做题状态
    getFinishedRes() {
      const { query } = this.$route
      utilV2.postData(ApiPath.hsk_get_list_answer, { ...query }, (data) => {
        console.log(this.resourceList)
        this.answerNotesArray = data.questionAnswers
        this.isMarked = data.mark_status
        console.log(this.answerNotesArray)
        // 得到记录合并对象
        let newQuestionArr = []
        let tempBigIndex = ''
        if (this.answerNotesArray.length) {
          this.resourceList.forEach((item) => {
            item.dataInfo.forEach((type) => {
              type.questionList.forEach((eg) => {
                if (eg.index) {
                  console.log(eg.index)
                  this.answerNotesArray[eg.index - 1].nnum = eg.nnum
                  this.answerNotesArray[eg.index - 1].num = eg.num
                  this.answerNotesArray[eg.index - 1].ifGroup = eg.ifGroup
                  // 重新改变judge规则
                  Object.assign(eg, this.answerNotesArray[eg.index - 1], {
                    judge: this.answerNotesArray[eg.index - 1].scores / eg.score >= 0.8 ? 1 : 0,
                  })
                  // lr的questions内需要存用户的得分；即scores字段；套题内含有主观题的处理
                  if (
                    eg.topic_type == 'lr' ||
                    eg.topic_type == 'rr' ||
                    eg.topic_type == 'kt' ||
                    eg.topic_type == 'ts'
                  ) {
                    if (eg.bigIndex != tempBigIndex) {
                      tempBigIndex = eg.bigIndex
                      newQuestionArr = []
                    }
                    let currentIndex = eg.index

                    let oldQuestionItem = eg.questions.find((item) => {
                      return item.index == currentIndex
                    })
                    let newQuestionItem = Object.assign(
                      { scores: eg.scores, judge: eg.judge },
                      oldQuestionItem
                    )
                    newQuestionArr.push(newQuestionItem)
                    eg.questions = newQuestionArr
                  }
                }
              })
            })
          })
        }
        this.$nextTick(() => {
          this.$refs.progress.selectQues()
        })
      })
    },
    // 提交答案改变状态
    submitAnswer() {
      this.isSubmitAnswer = true
    },

    searchAnsNumber(code) {
      let i = 0
      this.resourceList.forEach((item) => {
        if (item.name == code) {
          item.dataInfo.forEach((data) => {
            data.questionList.forEach(() => {
              i++
            })
          })
        }
      })
      return i
    },
    // 根据数据以及code获取当天作答时长
    getAnsTimes(list, code) {
      return list.find((item) => {
        return item.segmentCode == code
      }).duration
    },
    goBack() {
      this.$router.back()
    },
    /** 点击退出登录按钮所以在跳转前调用logout */
    checkLogout() {
      if (this.onClickLogout) {
        this.$store.dispatch('user/handleLogout', { reLogin: false })
      }
    },
  },
  // 离开页面时先保存作答记录
  beforeRouteLeave(to, from, next) {
    analytics.logEvent('hskweb_mockClick_beforeRouteLeave', {
      to: to.fullPath,
      from: from.fullPath,
    })
    // ...
    if (
      this.isSubmitAnswer ||
      this.$route.query.paperStatus == 1 ||
      this.paperOff ||
      !this.isLogin
    ) {
      window.onbeforeunload = null
      next()
      this.playStop()
    } else {
      this.$store.dispatch('notifLogout', false)
      let token = getToken()
      backLayerHandler(
        async () => {
          // 确定后执行的操作
          let mixpanelParams = {
            paper_type: this.paperType,
            exam_type: this.examType,
          }
          analytics.logEvent('hskweb_examquit_click', mixpanelParams)
          this.$refs.progress.$refs.countDown && this.$refs.progress.$refs.countDown.pause()
          let status = this.$refs.progress.ansProgressStatus != 2
          this.playStop()
          localStorage.removeItem('bigIndex')
          token && (await this.$refs.progress.saveApiRequest('', status))
          this.checkLogout()
          window.onbeforeunload = null
          await next()
        },
        {
          type: 'default',
          msg: token ? this.$t('hsk_if_save') : this.$t('hsk_login_filed'),
          cancel: () => {
            //取消阻止本次返回跳转，回归到本页面url
            this.onClickLogout = false
            next(false)
          },
        }
      )
    }
  },
  beforeDestory() {
    console.log('page before destory')
    this.$store.commit('SET_EXAMNATION_RECORD', false)
    window.onbeforeunload = null
    this.$player.onloaderrored = null
    this.$player.onplayerrored = null
  },
}
</script>

<style lang="scss" scoped>
::v-deep.el-dialog__footer {
  padding: 0;
}
::v-deep.el-dialog__header {
  padding: 0;
}
.dialog-footer {
  display: flex;
  align-items: center;
  border-top: 1px solid #f2f3f5;
  span {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 59px;
    cursor: pointer;
    &:first-child {
      border-right: 1px solid #f2f3f5;
    }
  }
}
.page-back {
  margin: 0 0 12px 98px;
  cursor: pointer;
  .desc {
    color: #2c2f46;
    font-family: 'Inter';
    font-weight: 500;
    font-size: 12px;
  }
}
</style>
